import { render, staticRenderFns } from "./SingProduct.vue?vue&type=template&id=2036dad1&scoped=true"
import script from "./SingProduct.vue?vue&type=script&lang=js"
export * from "./SingProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2036dad1",
  null
  
)

export default component.exports